import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=73a4e960&scoped=true"
import script from "./purchase.vue?vue&type=script&lang=js"
export * from "./purchase.vue?vue&type=script&lang=js"
import style0 from "./purchase.vue?vue&type=style&index=0&id=73a4e960&prod&lang=scss"
import style1 from "./purchase.vue?vue&type=style&index=1&id=73a4e960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4e960",
  null
  
)

export default component.exports